

<button
  mat-button
  class="dn-social-btn"
  [disableRipple]="!rippleEffect"
  [ngClass]="size"
  (click)="onClick($event)" 
>
  <span *ngIf="!loading; else loader">
    <img *ngIf="icon" class="dn-social-icon" alt="" [src]="icon">
    <span [ngClass]="{'dn-social-btn-text': icon}" >
        {{text}}
    </span>
    
  </span>

  <ng-template #loader>
    <dn-loader [loaderSize]="size" [isInPrimary]="false" />
</ng-template>
</button>


